"use strict";

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var bar = function bar(value, maxValue, maxBarLength) {
  var fractions = ['▏', '▎', '▍', '▋', '▊', '▉'];
  var barLength = value * maxBarLength / maxValue;
  var wholeNumberPart = Math.floor(barLength);
  var fractionalPart = barLength - wholeNumberPart;
  var bar = fractions[fractions.length - 1].repeat(wholeNumberPart);
  if (fractionalPart > 0) bar += fractions[Math.floor(fractionalPart * fractions.length)];
  return bar;
};

var chart = function chart(data) {
  var showValue = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  var maxBarLength = arguments.length <= 2 || arguments[2] === undefined ? 100 : arguments[2];

  var formatted = Object.keys(data).map(function (key) {
    return { key: key, value: data[key] };
  });
  var sorted = formatted.sort(function (a, b) {
    return b.value - a.value;
  });
  var maxValue = Math.max.apply(Math, _toConsumableArray(sorted.map(function (item) {
    return item.value;
  })));
  var maxKeyNameLength = Math.max.apply(Math, _toConsumableArray(sorted.map(function (item) {
    return item.key.length;
  })));
  return sorted.map(function (item) {
    var prefix = item.key + "．".repeat(maxKeyNameLength - item.key.length + 1);
    var barText = bar(item.value, maxValue, maxBarLength);
    var suffix = showValue ? ' ' + item.value : "";
    return prefix + barText + suffix;
  }).join('\n');
};

module.exports = chart;